// extracted by mini-css-extract-plugin
export var orderDetails = "_p1-2";
export var orderImage = "_p1-1";
export var orderMeta = "_p1-3";
export var orderSummary = "_p1-0";
export var rightArrow = "_p1-4";